"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopBannerSkeleton = exports.DescriptionSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _presentationComponents = require("@ori/presentation-components");
const TopBannerSkeleton = exports.TopBannerSkeleton = (0, _mui.styled)(_presentationComponents.TopBannerSkeleton)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, -3, 3, -3),
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(0, -3, 6, -3)
        }
    };
});
const DescriptionSkeleton = exports.DescriptionSkeleton = (0, _mui.styled)(_editorialComponents.DescriptionSkeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(10)
        }
    };
});
